export const platformConfig = {
    DNS: {
        onProofExternalClick: (window, proof) => {
            window.open('//' + proof.resource, '_blank');
        },
    },
    LINKEDIN: {
        onProofExternalClick: (window, proof, valid, location) => {
            const profileUrl = valid === 'true'
                ? location
                : 'https://www.linkedin.com/'.concat(proof.method).concat('/').concat(proof.resource);
            window.open(profileUrl, '_blank');
        },
    },
};
//# sourceMappingURL=proofs-platform-config.js.map